import { FAIcon, Theme, SearchDataStructure, AttributeTypes, TagStyle, Tag } from '../../../ui/components';
import { GetColumnsType } from '../../../ui/components/TableContainer/types/propsTypes';
import { DynamicObjectInterface } from '../../../sdk/type';
import { dateTimeToCustomFormat } from '../../../ui/utils';

type IProductBO = {
  [key: string]: DynamicObjectInterface;
};

export interface TeamData {
  teamId: number | null;
  teamName: string;
  teamSize?: string;
  description?: string;
  campaignId: string;
  campaignRecId: number | null;
  campaignName: string;
  campaignStart: string;
  campaignEnd: string;
  teamLeader?: string;
  coachId?: string;
  isIndividualTeam?: number | null;
  teamStartDate: string;
  teamEndDate: string;
  status: string;
  isDeleted: boolean;
}

export interface ParticipantDataStructure {
  campaignId: string;
  teamId: number;
  name: string;
  userId: string;
  status: string;
  recId?: number;
  weightIn: {
    weightInDate: string | null;
    height: number;
    weight: number;
    bodyFat: number;
    muscleKilogram: number;
    musclePercentage: number;
    acknowledgeBy: string | null;
    acknowledgeDateTime: string | null;
    remarks: string | null;
  };
  weightOut: {
    weightOutDate: string | null;
    height: number;
    weight: number;
    bodyFat: number;
    muscleKilogram: number;
    musclePercentage: number;
    weightLoss: number;
    bodyFatLoss: number;
    muscleGain: number;
    acknowledgeBy: string | null;
    acknowledgeDateTime: string | null;
    remarks: string | null;
  };
  purchaseDate: string | null;
  purchaseData: {
    orderNumber: number | null;
    orderPoint: number | null;
  };
  isIndividualAchieved?: string;
  loginId?: string;
  orderStatus?: string;
  weightInDate?: string;
  weightOutDate?: string;
}
export interface CreateTeamData {
  teamId: number | null;
  teamName: string;
  description?: string;
  campaignId: string;
  teamLeader?: string;
  coachId?: string;
  teamStartDate: string;
  teamEndDate: string;
  status: string;
  remark?: string;
  participant?: string[];
  checkbox?: string;
  isIndividualTeam?: number | null;
  campaignName?: string;
  coachDetail?: {};
}

export interface CampaignOption {
  campaignEnd: string;
  campaignId: string;
  campaignName: string;
  campaignStart: string;
  status: string;
  title: string;
  value: string;
}

export interface AddParticipantStructure {
  campaignId: string;
  userId?: number;
  loginId: string;
  coachId: string;
  enrollmentDate: string;
  endDate: string;
  pinLevel: string;
  remarks: string;
  orderNumber: string;
  directLeaderId: number;
  directLeaderName: string;
  directLeaderPinLevel: number;
  isNewAbo?: boolean;
  invisibleParticipant: {
    name: string;
    email: string;
    phone: string;
  };
}

export interface SearchedUserData {
  userId?: number;
  name: string;
  email: string;
  phone: string;
  status?: string;
  pinLevel: string | number;
  userPinName?: string;
  directLeaderId?: number;
  directLeaderName: string;
  directLeaderPinLevel: number;
  directLeaderPinName?: string;
  invisibleParticipant?: {
    name: string;
    email: string;
    phoneNumber: string;
  };
  isNewAbo?: boolean;
  gender?: string;
  race?: string;
  address?: string;
  loaName?: string;
  accountType?: string;
  highestPinLevel?: string | number;
  partyId?: string | number;
}

const dataSearchOption: SearchDataStructure[] = [
  // {
  //   name: 'Campaign Name',
  //   key: 'campaignName',
  //   type: AttributeTypes.Textbox,
  //   visibility: true,
  // },
  {
    name: 'Team Name',
    key: 'teamName',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Coach ID',
    key: 'coachId',
    type: AttributeTypes.Textbox,
    visibility: true,
  },
  {
    name: 'Participation Type',
    key: 'isIndividualTeam',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'yes',
        value: 'INDIVIDUAL',
      },
      {
        key: 'no',
        value: 'TEAM',
      },
    ],
  },
  {
    name: 'Team Winning',
    key: 'isGroupAchieved',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: true,
    dataset: [
      {
        key: 'yes',
        value: 'YES',
      },
      {
        key: 'no',
        value: 'NO',
      },
      {
        key: 'pending',
        value: 'PENDING',
      },
    ],
  },
  {
    name: 'Status',
    key: 'status',
    type: AttributeTypes.DropdownSingleSelect,
    visibility: false,
    dataset: [
      {
        key: 'true',
        value: 'ACTIVE',
      },
      {
        key: 'false',
        value: 'INACTIVE',
      },
    ],
  },
  {
    name: 'Start Date',
    key: 'teamStartDate',
    type: AttributeTypes.DateTimeSingle,
    visibility: false,
  },
  {
    name: 'End Date',
    key: 'teamEndDate',
    type: AttributeTypes.DateTimeSingle,
    visibility: false,
  },
];

const getTeamListConfig: GetColumnsType = (styles: Object, translation: Function, cb: DynamicObjectInterface) => [
  // {
  //   key: 'campaignName',
  //   text: translation('admin.teams.campaignName'),
  //   sortable: true,
  //   width: 5,
  //   render: (object: IProductBO) => <span>{object.campaignName}</span>,
  // },
  {
    key: 'teamName',
    text: translation('admin.teams.teamName'),
    sortable: true,
    width: 6,
    render: (object: IProductBO) => <span>{object.teamName}</span>,
  },
    {
    key: 'isIndividualTeam',
    text: translation('admin.teams.isIndividualTeam'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => <span>{object.isIndividualTeam}</span>,
  },
  {
    key: 'teamStartDate',
    text: translation('admin.teams.period'),
    sortable: true,
    width: 6,
    render: (object: IProductBO) => (
      <span>
        {object.teamStartDate !== null && object.teamEndDate !== null
          ? `${dateTimeToCustomFormat(object.teamStartDate)} - ${dateTimeToCustomFormat(object.teamEndDate)}`
          : '-'}
      </span>
    ),
  },
  {
    key: 'coachId',
    text: translation('admin.teams.coachId'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => <span>{object.coachId !== '' ? object.coachId : '-'}</span>,
  },
  {
    key: 'teamSize',
    text: translation('admin.teams.teamSize'),
    sortable: true,
    width: 4,
    render: (object: IProductBO) => <span>{object.teamSize !== '' ? object.teamSize : '-'}</span>,
  },
  {
    key: 'newABO',
    text: translation('admin.participant.isNewAbo'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => <span>{object.newABO}</span>,
  },
  {
    key: 'isGroupAchieved',
    text: translation('admin.teams.isGroupAchieved'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={
            object.isGroupAchieved === 'YES' ? Theme.SUCCESS : object.isGroupAchieved === 'NO' ? Theme.WARNING : Theme.BLUE
          }
          style={TagStyle.OUTLINE}
          text={object.isGroupAchieved}
        />
      </span>
    ),
  },
  {
    key: 'status',
    text: translation('admin.teams.status'),
    sortable: true,
    width: 3,
    render: (object: IProductBO) => (
      <span>
        <Tag
          theme={object.status === 'ACTIVE' ? Theme.SUCCESS : Theme.WARNING}
          style={TagStyle.OUTLINE}
          text={object.status}
        />
      </span>
    ),
  },
  {
    key: 'action',
    width: 2,
    text: 'Action',
    render: (object: IProductBO) => (
      <>
        <FAIcon
          iconName={'edit'}
          onClick={e => {
            cb?.onEdit(object.teamId);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Edit'}
        />
        {' | '}
        <FAIcon
          iconName={'trash-can'}
          onClick={e => {
            cb?.onDelete(object);
            e.stopPropagation();
          }}
          theme={Theme.PURPLE}
          title={'Delete'}
        />
      </>
    ),
  },
];

export { getTeamListConfig, dataSearchOption };
